// ============================================
// gsap scrollTrigger
// ============================================
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import Lenis from 'lenis';

// ============================================
// Lenis
// ============================================
const lerp = 0.12;
const duration = 1.6;

export let lenis = new Lenis({
  lerp,
  duration,
  smoothWheel: true,
  smoothTouch: false,
});

//初期設定
lenis.on('scroll', ScrollTrigger.update);
const _raf = (time) => lenis.raf(time * 1000);
gsap.ticker.add(_raf);
gsap.ticker.lagSmoothing(1000, 16);

const REINIT_MS = 60 * 1000;
setInterval(() => {
  gsap.ticker.remove(_raf);
  lenis.destroy();

  lenis = new Lenis({
    lerp,
    duration,
    smoothWheel: true,
    smoothTouch: true,
  });

  lenis.on('scroll', () => ScrollTrigger.update());
  gsap.ticker.add(_raf);
  ScrollTrigger.refresh();
}, REINIT_MS);

// ============================================
// ページ内リンク
// ============================================
function lenisPageScroll() {
  const links = document.querySelectorAll('a[href^="#"]:not(.-no-smooth, .l-header__skip-content)');
  if (links.length === 0) return;

  const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--size-header-h');
  const headerHeightNum = headerHeight.split('px')[0];

  const scrollToAnchor = (targetLink) => {
    if (!lenis) return;

    lenis.scrollTo(targetLink, {
      offset: Number(headerHeightNum) * -1.2,
      lerp: 0.2,
      duration: 1.2,
    });
  };

  links.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();

      let targetLink = el.getAttribute('href');
      if (!targetLink || targetLink === '#') targetLink = 'body';

      scrollToAnchor(targetLink);
    });
  });
}

// ============================================
// スクロールアニメーション
// ============================================
function inViewAnm() {
  ScrollTrigger.batch('.js-inview', {
    start: 'top 75%',
    end: 'bottom 75%',
    once: true,
    //markers: true,

    onEnter: (batch) => {
      batch.forEach((el) => el.classList.add('is-active'));
    },
  });
}

// 2カラムのナビ
// ============================================
function sideNav() {
  const nav = document.querySelector('.js-nav');
  if (nav) {
    const trigger = document.querySelectorAll('.js-nav__trigger');
    const sec = document.querySelectorAll('.js-nav__area');

    const md = gsap.matchMedia();
    md.add("(min-width: 1023px)", () => {

      trigger.forEach((trigger_item) => {
        ScrollTrigger.create({
          trigger: trigger_item,
          start: () => 'top 75%',
          end: () => 'bottom 75%',
          endTrigger: '.js-nav__area',
        });
      });

      //アクティブにする
      gsap.utils.toArray(sec).forEach((target) => {
        gsap.to(target, {
          scrollTrigger: {
            trigger: target,
            start: () => 'top 50%',
            end: () => 'bottom 50%',
            onEnter: () => {
              addClassNav(target);
            },
            onEnterBack: () => {
              addClassNav(target);
            },
          },
        });
      });

      function addClassNav(target) {
        const idName = target.id;
        trigger.forEach((item) => {
          const trigger_id = item.getAttribute('href').replace('#', '');
          if (trigger_id === idName) {
            item.classList.add('-current');
          } else {
            if (item.classList.contains('-current')) {
              item.classList.remove('-current');
            }
          }
        });
      }
    });
  }
}

export { lenisPageScroll, inViewAnm, sideNav };
